export default "__VITE_ASSET__CJmJvpxj__"